import { useCallback, useEffect, useState } from "react";

export const useDarkMode = () => {
  const [isDarkMode, setIsDarkMode] = useState(
    window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

    const handleChange = (event: any) => {
      setIsDarkMode(event.matches);
    };

    mediaQuery.addEventListener("change", handleChange);

    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, []);

  return isDarkMode;
};

/**
 * A custom React hook that executes a callback function when a specific key is pressed.
 * @param {string} targetKey - The key to listen for (e.g., 'Enter', 'Escape', 'a').
 * @param {(e?: KeyboardEvent) => void} callback - The function to execute when the key is pressed.
 */
export const useKeyPress = (
  targetKey: string,
  callback: (e?: KeyboardEvent) => void
): void => {
  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === targetKey) {
        callback(event);
      }
    },
    [targetKey, callback]
  );

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);
};
